var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductDescriptionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4964",
    "data-name": "Group 4964",
    transform: "translate(1340 18625)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_362",
    "data-name": "Ellipse 362",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(-1340 -18625)",
    fill: "#18beb3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5698",
    "data-name": "Path 5698",
    d: "M12,7.334V14H5.334V7.334H12M13.335,6H4v9.335h9.335Zm12,0H16V7.334h9.335Zm0,4H16v1.334h9.335Zm0,4H16v1.334h9.335Zm0,4H4v1.334H25.337Zm0,4H4v1.334H25.337Z",
    transform: "translate(-1333 -18618)",
    fill: "#18beb3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDescriptionIcon);
export default __webpack_public_path__ + "static/media/product-description-icon.fbe86ffcfe4211f83363399a74e6d33c.svg";
export { ForwardRef as ReactComponent };